import { Badge } from "@/components/ui/badge";
import type { IncidentStatus } from "@/api/models";

type AlertLevel = "none" | "low" | "high" | "stel" | "twa";

const labels: Record<AlertLevel, string> = {
  none: "OK",
  low: "Low",
  high: "High",
  stel: "STEL",
  twa: "TWA",
};

export function AlertBadge({ level }: { level: AlertLevel | undefined }) {
  const l = level ?? "none";
  const variant: React.ComponentProps<typeof Badge>["variant"] =
    l === "none" ? "secondary" : l === "low" ? "warning" : "destructive";
  return <Badge variant={variant}>{labels[l]}</Badge>;
}

const incidentStatusLabels: Record<IncidentStatus, string> = {
  active: "Active",
  cleared: "Cleared",
  reviewed: "Reviewed",
  finalized: "Finalized",
};

export function StatusPill({ status }: { status: IncidentStatus }) {
  return (
    <Badge variant={status === "active" ? "warning" : "secondary"}>
      {incidentStatusLabels[status]}
    </Badge>
  );
}
